<template>
  <form class="FormValidation" @submit.prevent="submit">
    <ValidationObserver ref="obs" #default="{ dirty, validate, valid }">
      <slot :validate="validate" />
      <transition appear name="slide-fade">
        <Notice v-if="errorMessage" ref="errors" class="danger">
          {{ errorMessage }}
        </Notice>
      </transition>
      <Emitter :value="dirty" @change="$emit('update:isDirty', $event)" />
      <Emitter :value="valid" @change="$emit('update:isValid', $event)" />
    </ValidationObserver>
  </form>
</template>

<script>
import { scrollTo } from '@router/smoothScroll'

function flattenErrors(errorTree) {
  return Object
    .values(errorTree)
    .reduce((errors, field) => [
      ...errors,
      Array.isArray(field) ? field : flattenErrors(field),
    ], [])
    .flat()
}

export default {
  data() {
    return {
      errorMessage: null,
    }
  },
  methods: {
    setErrors(errors) {
      this.errorMessage = flattenErrors(errors)[0] || null
    },
    reset() {
      return this.$refs.obs.reset()
    },
    async submit() {
      if (!await this.$refs.obs.validate()) {
        this.setErrors(this.$refs.obs.errors)
        return
      }

      this.$emit('submit')

      requestAnimationFrame(() => {
        try {
          this.$refs.obs.reset()
        } catch (error) {}
      })
    },
  },
  watch: {
    async errorMessage(errorMessage) {
      if (!errorMessage) return

      await this.$nextTick()

      if (this.$refs.errors.$el) scrollTo(this.$refs.errors.$el)
    },
  },
}
</script>
<style lang="scss">
.FormValidation {}
</style>
